/*!
 * devextreme-angular
 * Version: 26.1.6
 * Build date: Fri Oct 16 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */

/* tslint:disable:use-input-property-decorator */

import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Output,
    EventEmitter,
    ContentChildren,
    QueryList
} from '@angular/core';





import {
    DxIntegrationModule,
    NestedOptionHost,
    CollectionNestedOption,
} from 'devextreme-angular/core';
import { DxoFormOptions } from './base/form-options';

import {
    PROPERTY_TOKEN_items,
} from 'devextreme-angular/core/tokens';

@Component({
    selector: 'dxo-form',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [NestedOptionHost],
    inputs: [
        'accessKey',
        'activeStateEnabled',
        'alignItemLabels',
        'alignItemLabelsInAllGroups',
        'colCount',
        'colCountByScreen',
        'customizeItem',
        'disabled',
        'elementAttr',
        'focusStateEnabled',
        'formData',
        'height',
        'hint',
        'hoverStateEnabled',
        'isDirty',
        'items',
        'labelLocation',
        'labelMode',
        'minColWidth',
        'onContentReady',
        'onDisposing',
        'onEditorEnterKey',
        'onFieldDataChanged',
        'onInitialized',
        'onOptionChanged',
        'optionalMark',
        'readOnly',
        'requiredMark',
        'requiredMessage',
        'rtlEnabled',
        'screenByWidth',
        'scrollingEnabled',
        'showColonAfterLabel',
        'showOptionalMark',
        'showRequiredMark',
        'showValidationSummary',
        'tabIndex',
        'validationGroup',
        'visible',
        'width'
    ]
})
export class DxoFormComponent extends DxoFormOptions implements OnDestroy, OnInit  {
    @ContentChildren(PROPERTY_TOKEN_items)
    set _itemsContentChildren(value: QueryList<CollectionNestedOption>) {
        this.setChildren('items', value);
    }
    

    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    @Output() formDataChange: EventEmitter<any>;
    protected get _optionPath() {
        return 'form';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        this._createEventEmitters([
            { emit: 'formDataChange' }
        ]);

        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  imports: [
    DxoFormComponent
  ],
  exports: [
    DxoFormComponent
  ],
})
export class DxoFormModule { }
